<app-header />
<app-sidebar />
<app-right-sidebar />
<div class="main-layout-viewport d-flex flex-column h-100 overflow-hidden"
     [dir]="direction">
  <div class="main-layout-route-slot flex-grow-1 h-100 overflow-hidden">
    <router-outlet></router-outlet>
  </div>
</div>
